import { WEIGHT_EQUIPMENT_TYPE } from '../../../../constant'

function isDumbbellOrKettlebellEquipmentWeightUtil (type) {
  return [
    WEIGHT_EQUIPMENT_TYPE.DUMBBELL,
    WEIGHT_EQUIPMENT_TYPE.KETTLEBELL
  ].includes(type)
}

export { isDumbbellOrKettlebellEquipmentWeightUtil }
